"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iosArrowThinLeft = void 0;
var iosArrowThinLeft = {
  "viewBox": "0 0 512 512",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M189.8,349.7c3.1-3.1,3-8,0-11.3L123.4,264H408c4.4,0,8-3.6,8-8c0-4.4-3.6-8-8-8H123.4l66.3-74.4c2.9-3.4,3.2-8.1,0.1-11.2\r\n\tc-3.1-3.1-8.5-3.3-11.4-0.1c0,0-79.2,87-80,88S96,253.1,96,256s1.6,4.9,2.4,5.7s80,88,80,88c1.5,1.5,3.6,2.3,5.7,2.3\r\n\tC186.2,352,188.2,351.2,189.8,349.7z"
    },
    "children": []
  }]
};
exports.iosArrowThinLeft = iosArrowThinLeft;